/**
 * timer
 */

import anime from 'animejs';

import Page from '~/page/page';
import declOfNum from 'js/lib/declOfNum';

export default class Timer extends Page {
  init() {
    this.elements({
      days: '.js-timer-days',
      hours: '.js-timer-hours',
      minutes: '.js-timer-minutes',
      seconds: '.js-timer-seconds',
      number: '.js-timer-number',
      caption: '.js-timer-caption'
    });

    const date = this.$.root.data('expired');
    const [year, month, day = 1, hour = 24, minutes = 60] = date.split('-');

    this.expired = {
      time: new Date(year, month - 1, day, hour, minutes).getTime(),
      year: parseInt(year),
      month: parseInt(month),
      day: parseInt(day),
      hours: parseInt(hour),
      minutes: parseInt(minutes),
      seconds: 0
    };

    this.process();
  }
  get time() {
    const now = new Date().getTime();
    const expired = this.expired.time;

    this.remain = {
      common: expired - now
    };

    if (this.expired.time <= now) {
      this.setExpired();
      return null;
    }

    const days = this.getProp('days', this.remain.common);
    const hours = this.getProp('hours', this.remain.days);
    const minutes = this.getProp('minutes', this.remain.hours);
    const seconds = this.getProp('seconds', this.remain.minutes);

    return { now, values: { days, hours, minutes, seconds } };
  }
  getProp(id, time) {
    const map = {
      days: {
        round: time / 1000 / 60 / 60 / 24,
        ms: 1000 * 60 * 60 * 24
      },
      hours: {
        round: time / 1000 / 60 / 60,
        ms: 1000 * 60 * 60
      },
      minutes: {
        round: time / 1000 / 60,
        ms: 1000 * 60
      },
      seconds: {
        round: time / 1000,
        ms: 1000
      }
    };

    const unit = map[id];
    const round = Math.floor(unit.round);
    const ms = round * unit.ms;

    this.remain[id] = time - ms;

    return { round, ms };
  }
  process() {
    this.timer = setInterval(() => {
      const time = this.time;

      if (null === time) return;

      const map = {
        days: {
          $el: this.$.days,
          time: time.values.days.round,
          caption: ['день', 'дня', 'дней']
        },
        hours: {
          $el: this.$.hours,
          time: time.values.hours.round,
          caption: ['час', 'часа', 'часов']
        },
        minutes: {
          $el: this.$.minutes,
          time: time.values.minutes.round,
          caption: ['минута', 'минуты', 'минут']
        },
        seconds: {
          $el: this.$.seconds,
          time: time.values.seconds.round,
          caption: ['секунда', 'секунды', 'секунд']
        }
      };
      this.update(map);
    }, 1000);
  }
  setExpired() {
    this.$.root.addClass('is-expired');
    clearInterval(this.timer);
  }
  update(map) {
    for (let key in map) {
      const current = map[key];
      const time = current.time;

      const $el = current.$el;
      const $number = $el.find(this.$.number);
      const $caption = $el.find(this.$.caption);

      this.render($number, time < 10 ? `0${time.toString()}` : time);
      this.render($caption, declOfNum(time, current.caption));
    }
  }
  render($el, value) {
    if ($el.text() == value) return;

    const targets = $el.get(0);

    anime({
      targets,
      translateY: -5,
      duration: 400,
      easing: 'easeInCubic',
      opacity: 0,
      complete: () => {
        $el.text(value);
        $el.css({ transform: 'translateY(5px)' });

        anime({
          targets,
          translateY: 0,
          delay: 100,
          duration: 400,
          easing: 'easeOutCubic',
          opacity: 1
        });
      }
    });
  }
}

Page.mount(Timer, '.js-timer');
